import React, { useContext, useEffect, useRef, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { CardElement, Elements, useStripe, useElements } from '@stripe/react-stripe-js';

import Spacer from 'components/spacer';
import Button from 'components/button';
import InputContainer from 'components/input-container';

import { STRIPE_API_KEY  } from 'constants/index';

import If from 'conditionals/if';

import LocaleContext from 'contexts/locale-context';

import './index.css';

const CARD_OPTIONS = {
  hidePostalCode: true,
  iconStyle: 'solid',
  style: {
    base: {
      fontSize: '18px',
      fontSmoothing: 'antialiased',
    },
    invalid: {
    },
  },
};

const onEmailChange = setEmail => e => setEmail(e.target.value)

const Payment = ({ allowPayment, disableEmail, loading, onSubmit }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [cardComplete, setCardComplete] = useState(false);
    const [email, setEmail] = useState(null);
    
    const emailRef = useRef(null);

    const { translations } = useContext(LocaleContext);
  
    const jsTranslations = translations.js;

    const enableButton = cardComplete && (disableEmail || email) && allowPayment;

    useEffect(() => {
        if (emailRef && emailRef.current) emailRef.current.focus();
    }, [])
  
    /**
       * Define function to handle event listener for
       * stripe cardElement. This should enable and disable
       * the pay button.
       * @param {*} event 
       */
    const changeListener = function(event) {
      if (event.complete) {
        setCardComplete(true);
      } else if (event.error) {
        setCardComplete(false);
      } else {
        setCardComplete(false);
      }
    }
  
    return (
      <form
        style={{ width: '100%' }}
        onSubmit={ev => {
          const cardElement = elements.getElement(CardElement)
          onSubmit(ev, { elements, stripe, cardElement, email })
        }}
      >
        <div className='payment__container'>
          <div className='payment__card-container'>
            
            <If condition={!disableEmail}>
              <InputContainer
                required
                label={jsTranslations.email}
              >
                {({ class: className }) => {
                  return (
                    <input
                      className={className}
                      placeholder={'Email'}
                      required
                      type='email'
                      style={{ fontSize: '18px' }}
                      onChange={onEmailChange(setEmail)}
                      ref={emailRef}
                    />
                  )
                }}
              </InputContainer>
            </If>
            <InputContainer
              required
              label={jsTranslations.card_details}
            >
              {() => {
                return (
                  <CardElement
                    options={CARD_OPTIONS}
                    onReady={(el) => {
                      if (disableEmail) el.focus()
                    }}
                    onChange={changeListener}
                  />
                )
              }}
            </InputContainer>
            
          </div>
  
          <Spacer size='m' />
  
          <Button type='submit' disabled={!enableButton} loading={loading}>
            {jsTranslations.pay}
          </Button>
        </div>
      </form>
    )
}

Payment.defaultProps = {
  onSubmit: () => {},
  allowPayment: true
}

const stripePromise = loadStripe(STRIPE_API_KEY);

export default props => {
  return (
    <Elements stripe={stripePromise}>
        <Payment {...props}/>
    </Elements>
  )
}